import GoalsView from '@/views/app/goals/goals-view.vue'
import GoalsDealerView from '@/views/app/goals/goals-dealer.view.vue'
import GoalsBranchView from '@/views/app/goals/goals-branch.view.vue'
import GoalsZoneView from '@/views/app/goals/goals-zone.view.vue'
import GoalsSellerView from '@/views/app/goals/goals-seller.view.vue'
import GoalsSellerDetail from '@/views/app/goals/goals-seller-detail.vue'
import GoalsGuards from '@/guards/goals.guards'
import multiguard from 'vue-router-multiguard'

export default [
  {
    path: 'goals',
    component: GoalsView,
    children: [

      {
        path: '',
        name: 'goals',
        redirect: GoalsGuards.onRedirect
      },
      {
        path: 'dealer/:id?',
        name: 'goals-dealer',
        component: GoalsDealerView,
        beforeEnter: multiguard([
          GoalsGuards.onQueryGoalItems('dealers'),
          GoalsGuards.onQuery('dealerGoals'),
          GoalsGuards.onQueryMetGoals('dealerGoals', 'dealers/items'),
          GoalsGuards.onQueryGlobalGoals('dealerGoals'),
          GoalsGuards.onQueryGlobalMetGoals('dealerGoals'),
          GoalsGuards.onQueryAssignedGoals('all')
        ])
      },
      {
        path: 'branch/:id?',
        name: 'goals-branch',
        component: GoalsBranchView,
        beforeEnter: multiguard([
          GoalsGuards.onQueryGoalItems('branches'),
          GoalsGuards.onQuery('branchGoals'),
          GoalsGuards.onQuery('dealerGoals'),
          GoalsGuards.onQueryMetGoals('branchGoals', 'branches/items'),
          GoalsGuards.onQueryGlobalGoals('dealerGoals'),
          GoalsGuards.onQueryGlobalMetGoals('dealerGoals'),
          GoalsGuards.onQueryAssignedGoals('branch')
        ])
      },
      {
        path: 'seller/:branchId?/:id?',
        name: 'goals-seller',
        component: GoalsSellerView,
        beforeEnter: multiguard([
          GoalsGuards.onQueryGoalItems('sellers'),
          GoalsGuards.onQuery('sellerGoals'),
          GoalsGuards.onQueryMetGoals('sellerGoals', 'sellers/items'),
          GoalsGuards.onQueryBranchId('branchGoals'),
          GoalsGuards.onQueryMetGoalsBranchId('branchGoals'),
          GoalsGuards.onQueryAssignedGoals()
        ])
      },
      {
        path: 'seller-goals',
        name: 'seller-my-goals',
        component: GoalsSellerDetail,
        beforeEnter: multiguard([GoalsGuards.onQueryGoalItems('sellers'), GoalsGuards.onQuerySellerGoals, GoalsGuards.onQueryMetGoals('sellerGoals', 'sellers/items')])
      }
    ]
  },
  {
    path: 'goals-target',
    component: GoalsView,
    children: [

      {
        path: '',
        name: 'goals-target',
        redirect: GoalsGuards.onTargetRedirect
      },
      {
        path: 'zones/:id?',
        name: 'goals-target-zone',
        component: GoalsZoneView,
        beforeEnter: multiguard([
          GoalsGuards.onQueryZoneGoalItems(),
          GoalsGuards.onQuery('zoneGoals'),
          GoalsGuards.onQueryMetGoals('zoneGoals', 'zones/items')
        ])
      },
      {
        path: 'branch/:id?',
        name: 'goals-target-branch',
        component: GoalsBranchView,
        props: {hideActions: true, hideParent: true, focusFirst: true},
        beforeEnter: multiguard([
          GoalsGuards.onQueryGoalItems('branches'),
          GoalsGuards.onQuery('branchGoals'),
          GoalsGuards.onQueryMetGoals('branchGoals', 'branches/items')
        ])
      }
    ]
  },
  {
    path: 'goals-branch',
    component: GoalsView,
    children: [
      {
        path: ':id?',
        name: 'admin-goals-branch',
        component: GoalsBranchView,
        props: {hideActions: true, hideParent: true, focusFirst: true},
        beforeEnter: multiguard([
          GoalsGuards.onQueryGoalItems('branches'),
          GoalsGuards.onQuery('branchGoals'),
          GoalsGuards.onQueryMetGoals('branchGoals', 'branches/items'),
          GoalsGuards.onQueryAssignedGoals('seller', 'branchId')
        ])
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/goals/index.js